module.exports = __webpack_public_path__ + "img/text.7edf0523.png";